export interface IFoundZip {
  city: string;
  countryCode: string;
  zip: string;
}
